// extracted by mini-css-extract-plugin
export default {"container":"InspectionCompletePage_container__2x0RN","label":"InspectionCompletePage_label__-Klqu","sublabel":"InspectionCompletePage_sublabel__mFWZG"};